import { render, staticRenderFns } from "./TemplateSettingDetail.vue?vue&type=template&id=faaaa0e6"
import script from "./TemplateSettingDetail.vue?vue&type=script&lang=js"
export * from "./TemplateSettingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports